import React from 'react';

/**
 * Renders a pretty-printed representation of an object.
 */
export const ObjectPrettyPrinter = ({ object }: { object: Record<string, unknown> }) => {
  return <pre style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(object, null, 2)}</pre>;
};
